import { Box } from "@mui/material";
import { FacilitySetting } from "../services/workplaceSettings";
import { SettingsItemTitle } from "./SettingsItemTitle";
import { SettingsItemAction } from "./SettingsItemAction";

interface SettingsItemProps {
  item: FacilitySetting;
  isLoading: boolean;
}

export function SettingsItem({ item, isLoading }: SettingsItemProps) {
  if (item.hidden) {
    return null;
  }

  return (
    <Box
      role="row"
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingY: "16px",
        borderBottom: "1px solid #f0f0f0",
        "&:last-child": {
          borderBottom: "none",
        },
        "&:hover": {
          backgroundColor: "#fafafa",
        },
      }}
    >
      <Box
        sx={{
          flex: 1,
          maxWidth: 800,
          paddingRight: "16px",
        }}
      >
        <SettingsItemTitle title={item.title} subtitle={item.subtitle} hidden={item.hidden} />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          minWidth: "100px",
        }}
      >
        <SettingsItemAction item={item} isLoading={isLoading} />
      </Box>
    </Box>
  );
}
